import React,{Component} from "react";
import TitleBar from '../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';
import  NavigationBar from '../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import WorkorderTab from './WorkorderTabSystem';
import { connect } from 'react-redux';

class PreventativeMaintenance extends Component{
    componentWillMount(){
        sessionStorage.setItem('activeContent',2);  
    }
     render(OnPremises){
           let IsOnPremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
       return(
            <div className="Ensemble">
            {
                  !IsOnPremise ? 
                  <div>
                        <NavigationBar />
                        <TitleBar parentToChildData={"Work Order Management"} istabView={true} />
                        <div className="Ensemble_Content margin_top">
                              <WorkorderTab/>
                        </div>
                        <Footer />
                  </div> : <div className="Ensemble_Content_FullPage"><WorkorderTab /></div>
            }
            </div>
        );
    }
};

const mapStateToProps = state => {
      return {
            OnPremises: state.authService.IsOnPremise
      };
};
export default connect(mapStateToProps, null)(PreventativeMaintenance);